export enum OptimoveSource {
    TradingPlatform = "trading_platform",
    Deposit = "deposit",
    Kyc ="kyc"
}
